export default "__VITE_ASSET__DrDHV5WH__"